import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

var SvgLoader = function SvgLoader(props) {
  return _jsxs("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    role: "img"
  }, props), {}, {
    children: [_jsx("path", {
      fill: props.color || '#909090',
      d: "M3.066 7.203c-.546-.089-1.07.284-1.066.838a6 6 0 0 0 10.304 4.14c.385-.397.265-1.029-.19-1.343-.456-.314-1.074-.187-1.491.176A3.997 3.997 0 0 1 4.02 8.361c-.05-.55-.408-1.07-.955-1.158ZM12.998 8c.553 0 1.01-.452.918-.998a5.999 5.999 0 0 0-9.394-3.891c-.451.32-.447.964-.056 1.355s1.022.378 1.498.096a3.995 3.995 0 0 1 5.906 2.446c.138.536.574.992 1.128.992Z"
    }), _jsx("path", {
      fill: props.color || '#909090',
      d: "M2.636 5.183a.452.452 0 0 1 .728 0L4.914 7.3c.214.292.003.7-.363.7H1.449a.441.441 0 0 1-.363-.7l1.55-2.117ZM13.364 9.817a.453.453 0 0 1-.728 0L11.086 7.7a.441.441 0 0 1 .363-.7h3.102c.365 0 .577.408.363.7l-1.55 2.117Z"
    })]
  }));
};

export default SvgLoader;